
import './styles.scss'
import type { CSSProperties } from 'react'

interface Props {
  style?: CSSProperties
  errors: Array<Record<string, unknown>>
}

export function ErrorMessage ({ style, errors }: Props): JSX.Element | null {
  if (!errors || !errors.length) {
    return null
  }

  return (
    <div className='nh-error-wrapper'>
      {errors.map((e, index) => (
        <div
          className='nh-error-message'
          key={`error-message${index}`}
          style={style}
        >
          <>
            *
            {e}
          </>
        </div>
      ))}
    </div>
  )
}
